import firebase from '../config/firebase.config';
import httpClient from '../config/httpClient';
import { fetchApplicationInfoMapping } from './applicationInfo';

const database = firebase.firestore();

async function uploadImage(image, fileName) {
  try {
    console.log({ image, fileName });
    const response = await httpClient.post('/uploadImage', { image, fileName });
    const res = response.data;
    console.log('data in uploadImage', res.result);
    if (res.success) {
      return { success: true, data: res.result };
    }
    return { success: false, data: res.message };
  } catch (err) {
    console.log(err);
    return { success: false, data: err };
  }
}

const createPOC = async (payload = {}) => {
  try {
    console.log({ payload });
    const {
      totalTimeTracked,
      timeTracked,
      applicationName,
      imageList = [],
    } = payload;
    const userToken = 'test-token-0000';
    const formData = new FormData();
    formData.append('totalTimeTracked', totalTimeTracked);
    formData.append('timeTracked', timeTracked);
    formData.append('applicationName', applicationName);
    formData.append('userToken', userToken);
    if (imageList.length > 0) {
      [...imageList].forEach((file) => formData.append('files', file));
    }
    const res = await httpClient.post('/createPOC', formData);
    const data = res.data;
    console.log({ data });
  } catch (error) {
    console.log(error);
  }
};

function getPOCData(payload = {}) {
  const {
    userId,
    teamId,
    userToken,
    companyId = 'wal3xRi8taICeQZN235Z',
    formattedDate,
  } = payload;
  try {
    console.log('companyId=====>', companyId);
    return database
      .collection('variant2_WfhGO_DB')
      .doc(companyId)
      .collection('members')
      .doc(userToken)
      .collection('days')
      .doc(formattedDate)
      .get()
      .then((response) => {
        if (response) {
          const docData = response.data();
          return {
            success: true,
            data: docData?.calculatedTimelog ? docData?.calculatedTimelog : {},
          };
        } else {
          return {
            success: false,
            data: {},
            message: 'Document does not exist',
          };
        }
      })
      .catch((error) => {
        console.error(error);
        return {
          success: false,
          data: error,
        };
      });
  } catch (error) {
    console.error(error);
    return {
      success: false,
      data: error,
    };
  }
}

async function getApplicationInfo() {
  try {
    const data = await fetchApplicationInfoMapping();
    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      data: error,
    };
  }
}

export default {
  uploadImage,
  createPOC,
  getPOCData,
  getApplicationInfo,
};
